import React from 'react';
import { Link } from 'react-router-dom';
import icon1 from './web-developer.gif';
import icon2 from './branding.gif';
import icon3 from './microphone.gif';
import icon4 from './content-media.gif';
import icon5 from './digital-art.gif';
import icon6 from './engagement.gif';

export default function Services() {
  const servicesArray = [
    {
      name: 'Programming services',
      img: icon1,
      //link:'webDevelopment',
      animationfrom: 'left',
    },
    {
      name: 'Branding',
      img: icon2,
      //link:'mobileApplication',
      animationfrom: 'down',
    },
    {
      name: 'Content Creation',
      img: icon6,
      //link:'',
      animationfrom: 'right',
    },
    {
      name: 'Social Media Mangement',
      img: icon4,
      link: 'graphicDesign',
      animationfrom: 'left',
    },
    {
      name: 'Exterior Design',
      img: icon5,
      link: 'animation',
      animationfrom: 'down',
    },
    {
      name: 'Voice over',
      img: icon3,
      link: 'videoEditing',
      animationfrom: 'right',
    },
  ];

  return (
    <>
      <div className='relative lg:mb-48 overflow-hidden lg:overflow-visible mt-36 mb-10 md:mb-10' id='services'>
        <div className='container grid grid-cols-12 justify-items-center w-11/12 m-auto px-7 md:px-12'>
          {/* title */}
          <div className='col-span-12 relative justify-self-start' id='serviceTitle'>
            <h3 className='font-semibold md:text-6xl text-4xl gradiantText pb-0 lg:pb-1'>Services</h3>
          </div>
          <div className='col-span-12 w-full md:mb-20 md:mt-10 mb-16 mt-5' id='serviceTitle'>
            <hr className='border-t-2 border-[var(--secondryColor)] w-full' />
          </div>
          <div className='col-span-12 py-3 md:py-0' id='serviceContent'>
            <div className='relative grid grid-cols-12 gap-6 lg:gap-10'>
              {servicesArray.map((elem, idx) => (
                <div className='col-span-6 md:col-span-4 m-auto md:m-0' key={idx} id={elem.animationfrom}>
                  {elem.name == 'Desktop Applications' ? (
                    <div className='card w-[8rem] h-48 lg:h-auto lg:w-[21rem] border-[0.1px] border-[var(--borderStrokeColor)] serviceCard hover:scale-105 transition-all ease-in-out'>
                      <figure className='px-10 pt-10'>
                        <img src={elem.img} alt={elem.name} className='rounded-xl w-full' />
                      </figure>
                      <div className='card-body items-center text-center'>
                        <h2 className='card-title text-white text-sm lg:text-xl'>{elem.name}</h2>
                      </div>
                    </div>
                  ) : (
                    <Link to={`/categoryDetails/${elem.link}`} onClick={() => { document.documentElement.style.scrollBehavior = 'auto'; }}>
                      <div className='card w-[8rem] h-48 lg:h-auto lg:w-[21rem] border-[0.1px] border-[var(--borderStrokeColor)] serviceCard hover:scale-105 transition-all ease-in-out'>
                        <figure className='px-10 pt-10'>
                          <img src={elem.img} alt={elem.name} className='rounded-xl w-full' />
                        </figure>
                        <div className='card-body px-2 items-center text-center'>
                          <h2 className='card-title text-white text-sm lg:text-xl'>{elem.name}</h2>
                        </div>
                      </div>
                    </Link>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
